import { useMediaQuery } from "react-responsive";

export const MobileCalVW = (px: number) => `${(px / 360) * 100}vw`;
export const MobileCal = (px: number) => `${(px / 360) * 100}`;
export const TabletCalVW = (px: number) => `${(px / 1024) * 100}vw`;
export const DeskTopCalVW = (px: number) => `${(px / 1920) * 100}vw`;
export const MaxCalVW = (px: number) => `${(px / 1718) * 100}vw`;

export const useIsMobile = () => {
  return useMediaQuery({ maxWidth: 768 });
};

export const useIsTablet = () => {
  return useMediaQuery({ maxWidth: 1350 });
};
